<template>
  <gj-modal
      size="680_auto"
      :visible.sync="modalVisible"
  >
    <template #header>导入</template>
    <template #content>
      <div
          v-loading="loading"
          element-loading-text="文件上传成功，正在验证导入文件验证"
          element-loading-spinner="el-icon-loading"
      >
        <div class="gj-mb16">
          <div class="gj-mb16">


            <gj-required>店铺/国家</gj-required>
            <gj-market-select
                style="margin-left: 10px"
                v-model="marketId"
                :clearable="false"
                width="120px"
                @input-option="inputOption"
            ></gj-market-select>

            <gj-required style="margin-left: 15px">报表类型</gj-required>
            <gj-select
                v-model="reportType"
                :options="[
                { id: 'marketId', text: '日期业务报告' },
                { id: 'asin', text: '子ASIN业务报告' },
                { id: 'variationAsin', text: '父ASIN业务报告' },
                { id: 'msku', text: 'MSKU业务报告' },
              ]"
                placeholder="报表类型"
                :clearable="false"
                width="140px"
                style="margin-left: 10px"
            ></gj-select>

            <gj-required style="margin-left: 15px">数据日期</gj-required>
            <gj-date-picker
                style="margin-left: 10px"
                type="date"
                v-model="recordDate"
                :clearable="false"
                width="120px"
            ></gj-date-picker>

          </div>
          <gj-upload
              :disabled="marketId === null || recordDate === null || reportType===null"
              container-type="dateRangeReport"
              @uploadAfter="uploadAfter"
              :validFileSize="200"
              :acceptType="[FileTypeEnum.CSV, FileTypeEnum.X_CSV, FileTypeEnum.XLS, FileTypeEnum.XLSX, FileTypeEnum.X_XLS]"
          >
            <template #tip>
              <span>只能上传CSV/XLS文件</span>
            </template>
          </gj-upload>
        </div>
        <gj-import-alert>
          <template #content>
            <li class="gj-import-alert--rule">
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <span class="colorRed">重要提示！</span>
            </li>
            <li class="gj-import-alert--rule">
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <span>下载位置：Reports->Business Reports</span>
            </li>
            <li class="gj-import-alert--rule">
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <div class="flex">
                <span style="flex: none;">下载位置：</span>
                <div>MSKU=US:Detail Page Sales and Traffic by SKU<br>
                  子ASIN=US:Detail Page Sales and Traffic by Child Item<br>
                  父ASIN=US:Detail Page Sales and Traffic by Parent Item
                </div>
              </div>
            </li>
            <li class="gj-import-alert--rule">
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <span>导出时，请选择该报表的所有项，报告中的内容、名称不可更改，不可删除</span>
            </li>
            <li class="gj-import-alert--rule">
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <span>重复导入将自动覆盖原始数据</span>
            </li>
            <li class="gj-import-alert--rule">
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <span>支持CSV、XSL格式</span>
            </li>
          </template>
        </gj-import-alert>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {FileTypeEnum} from "@/components/upload/enum";
import {modalMixIn, uploadMixin} from "@/minxins";
import {convertToDate} from "@/utils/date.util";
import {businessImport} from "@/api/statistics";

export default {
  name: "add-import-modal",
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      loading: false,
      FileTypeEnum,
      countryCode: null,
      marketId: null,
      reportType: null,
      recordDate: null,
    }
  },
  methods: {
    inputOption(option) {
      this.countryCode = option.countryCode;
      this.marketId = option.id;
    },
    uploadAfter(attId, data, uploadCb) {
      this.loading = true;
      businessImport({
        attachmentId: attId,
        countryCode: this.countryCode,
        marketId: this.marketId,
        reportType: this.reportType,
        recordDate: convertToDate(this.recordDate)
      }).then(res => {
        if (res.code !== 0) {
          this.$gjMessage.error(res.msg);
        } else {
          this.$gjMessage.success('导入成功！正在后台更新数据，请稍等');
          uploadCb(res)
          this.$emit('importSuccess');
        }
      }).catch(() => {
        uploadCb('error')
      }).complete(() => {
        this.loading = false
        this.$emit('import');
      });
    },
    // uploadAfter(attId, data, uploadCb) {
    //   this.loading = true;
    //   let params = `attachmentId=${attId}&recordMonth=${convertToMonth(this.recordMonth)}&countryCode=${this.countryCode}&marketId=${this.marketId}`
    //   businessImport(params).then((res) => {
    //     this.$gjImportHandle(res, uploadCb);
    //   }).catch(() => {
    //     uploadCb('error')
    //   })
    //       .complete(() => this.loading = false);
    // }
  }
}
</script>

<style scoped lang="scss">
.gj-import-alert--rule {
  font-size: 12px;
  list-style-type: none;
  display: flex;
  // align-items: center;
  line-height: 26px;

  .gj-import-alert_box {
    height: 24px;
    display: flex;
    align-items: center;
    margin-right: 8px;
  }

  .gj-import-alert--dot {
    min-height: 8px;
    min-width: 8px;
    max-width: 8px;
    max-height: 8px;
    border-radius: 50%;
    background: #999999;
    opacity: 0.4;
  }
}
</style>